import { FC } from 'react';
import { ShopperMesh } from '../../../../../types';
import './ShopperOrderNumber.less';

interface ShopperOrderNumberProps {
  shopperMesh: ShopperMesh;
  selectedQueueLineColor: string;
  isSelectedShopper: boolean;
  isOverlapping: boolean;
  isFirstInLine: boolean;
  isMiddleInLine: boolean;
  isLastInLine: boolean;
}

const ShopperOrderNumber: FC<ShopperOrderNumberProps> = ({
  shopperMesh,
  selectedQueueLineColor,
  isSelectedShopper,
  isOverlapping,
  isFirstInLine,
  isMiddleInLine,
  isLastInLine,
}) => {
  return (
    <div className="shopper-order-number-wrapper">
      {(isFirstInLine || isMiddleInLine) && (
        <div
          style={{
            height: '15px',
            width: '3px',
            background: selectedQueueLineColor,
            position: 'absolute',
            top: '40px',
          }}
        />
      )}

      <div
        className="shopper-order-number"
        style={{
          borderColor: selectedQueueLineColor,
          color: isSelectedShopper ? '#ffffff' : selectedQueueLineColor,
          background: isSelectedShopper ? selectedQueueLineColor : '#ffffff',
        }}
      >
        {shopperMesh.userData.orderInLine}
      </div>

      {isOverlapping && (
        <div
          className="alert-overlapping-shopper"
          title="Shoppers are overlapping and need to be moved."
        >
          !
        </div>
      )}

      {(isLastInLine || isMiddleInLine) && (
        <div
          style={{
            height: '15px',
            width: '3px',
            background: selectedQueueLineColor,
            position: 'absolute',
            bottom: '40px',
          }}
        />
      )}
    </div>
  );
};

export default ShopperOrderNumber;
